<template>
    <div class="container eventWaiver">
      <v-row v-if="age18">
        <v-col md="12" cols="12">
          <WarningAlert
            :codeHtml="`${$t('eventWaiver.alert_text_1')}<br />${$t('eventWaiver.alert_text_2')}<br />${$t('eventWaiver.alert_text_3')}<br />${$t('eventWaiver.alert_text_4')}`"
          ></WarningAlert>              
        </v-col>
        <v-col v-if="age18" md="12" cols="12" class="pt-0 pb-0" >
            <v-row no-gutters>
                <v-col md="12" class="text-right">
                  <v-btn :color="`${buttonColor}`" dark class="mb-2 mr-2" @click="goEventRegistration">
                  {{ $t("eventWaiver.event_registration")}}
                  </v-btn>
                  <v-btn :color="`${buttonColor}`" dark class="mb-2" @click="addRegistrant">
                  {{ $t("eventWaiver.sign_waiver_now")}}
                  </v-btn>
                </v-col>
            </v-row>
        </v-col>
        <v-col v-if="age18" md="12" cols="12" class="pt-0">
        <v-row no-gutters>
            <v-col md="6">{{ $t("eventWaiver.text_1") }}</v-col>
            <v-col md="6">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('common.search')"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
        </v-row>
          <v-data-table
            :headers="headers"
            :items="filteredWaivers"
            :options="{itemsPerPage:-1}"
            :search="search"
            :custom-filter="customFilter"
            :loading="loadingData"
            :loading-text="$t('yourRegistration.loading_text')"
            class="elevation-1 mt-2"
            dense
            :footer-props="{
              'items-per-page-text': $t('dataTable.rowsPerPageText'),
              'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
            }"
            :no-data-text="$t('dataTable.noDataText')"
            :headerProps="{
              'sort-by-text': $t('dataTable.sortByText')
            }"
          >
            <template v-slot:top>
              <v-dialog v-model="dialogDelete" max-width="600px">
                <v-card>
                  <v-card-title class="headline">{{ $t('eventWaiver.delete_waiver') }}</v-card-title>
                  <v-card-text>
                    <p class="mt16">{{ $t('eventWaiver.sure_delete') }}</p>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn class="btn mb-2 mr-2" :color="`${buttonColor}`" @click="closeDelete">{{ $t('riders.cancel') }}</v-btn>
                    <v-btn
                          :color="`${buttonColor}`"
                          class="btn mb-2"
                          @click="deleteItemConfirm"
                          :disabled="disabledDelete"
                          :loading="disabledDelete"
                        >{{ $t('riders.delete') }}</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
              <template v-slot:[`item.view`]="{ item }">
                <v-icon small class="mr-2" @click="view(item)">fa far fa-eye</v-icon>
              </template>
              <template v-slot:[`item.eventDate`]="{ item }">
                {{ item.eventDate | formatDateForHumans(false) }}
              </template>
              <template v-slot:[`item.waiverStatus`]="{ item }">
                <span v-if="item.eventWaiverParticipantDeleted">
                  {{ $tc('riders.waiver_deleted') }}
                </span>
                <template v-else-if="item.signaturesRequired > 1">
                  <span v-if="item.allSignaturesComplete" style="color: green;">
                    {{ $t("waivers.waiversigned") }}
                  </span>
                  <span v-else style="color: orange;">
                    {{ item.signaturesSigned || 0 }}/{{ item.signaturesRequired }} {{ $t("waivers.waiversigned") }}
                  </span>
                </template>
                <span v-else>
                    <span :style="`${ item.waiverStatus=='NotSigned' ? 'color: red;' : '' }`">
                      {{ $te("common."+item.waiverStatus) ? $t("common."+item.waiverStatus) : item.waiverStatus }}
                </span>
                </span>
              </template>
              <template v-slot:[`item.participantType`]="{ item }">
                {{ $te("common."+item.participantType) ? $t("common."+item.participantType) : item.participantType }}
              </template>
            <template v-slot:[`item.actions`]="{ item }" >
              <v-icon small v-if="item.waiverStatus!='Signed' && item.waiverStatus!='Rejected'" @click="deleteItem(item)">fa far fa-trash-alt</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row no-gutters v-else>
        <v-col md="12" class="pa-3">
          <WarningAlert>
            <p class="mb-0 font-weight-bold">{{ $t("eventWaiver.alert_minor_1") }}</p>
            <p class="mb-0">{{ $t("eventWaiver.alert_minor_2") }}</p>
          </WarningAlert>
        </v-col>
        <v-col md="12" cols="12" class="pt-0">
          <v-data-table
            :headers="headers"
            :items="filteredWaivers"
            :search="search"
            :custom-filter="customFilter"
            class="elevation-1"
            dense
            :footer-props="{
              'items-per-page-text': $t('dataTable.rowsPerPageText'),
              'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
            }"
            :no-data-text="$t('dataTable.noDataText')"
            :headerProps="{
              'sort-by-text': $t('dataTable.sortByText')
            }"
          >
            <template v-slot:top>
              <v-dialog v-model="dialogDelete" max-width="600px">
                <v-card>
                  <v-card-title class="headline">{{ $t('eventWaiver.delete_waiver') }}</v-card-title>
                  <v-card-text>
                    <p class="mt16">{{ $t('eventWaiver.sure_delete') }}</p>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn class="btn mb-2 mr-2" :color="`${buttonColor}`" @click="closeDelete">{{ $t('riders.cancel') }}</v-btn>
                    <v-btn
                      :color="`${buttonColor}`"
                      class="btn mb-2"
                      @click="deleteItemConfirm"
                      :disabled="disabledDelete"
                      :loading="disabledDelete"
                    >{{ $t('riders.delete') }}</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template v-slot:[`item.view`]="{ item }">
              <v-icon small class="mr-2" @click="view(item)">fa far fa-eye</v-icon>
            </template>
            <template v-slot:[`item.eventDate`]="{ item }">
              {{ item.eventDate | formatDateForHumans(false) }}
            </template>
            <template v-slot:[`item.waiverStatus`]="{ item }">
                <span v-if="item.eventWaiverParticipantDeleted">
                  {{ $tc('riders.waiver_deleted') }}
                </span>
                <template v-else-if="item.signaturesRequired > 1">
                  <span v-if="item.allSignaturesComplete" style="color: green;">
                    {{ $t("waivers.waiversigned") }}
                  </span>
                  <span v-else style="color: orange;">
                    {{ item.signaturesSigned || 0 }}/{{ item.signaturesRequired }} {{ $t("waivers.waiversigned") }}
                  </span>
                </template>
                <span v-else>
                  <span :style="`${ item.waiverStatus=='NotSigned' ? 'color: red;' : '' }`">
                    {{ $te("common."+item.waiverStatus) ? $t("common."+item.waiverStatus) : item.waiverStatus }}
                </span>
                </span>
            </template>
            <template v-slot:[`item.participantType`]="{ item }">
                {{ $te("common."+item.participantType) ? $t("common."+item.participantType) : item.participantType }}
            </template>
            <template v-slot:[`item.actions`]="{ item }" >
              <v-icon small v-if="item.waiverStatus!='Signed' && item.waiverStatus!='Rejected'" @click="deleteItem(item)">fa far fa-trash-alt</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
        <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar"/>
        <v-dialog v-model="dialogWarningWaiver" max-width="900px">
            <v-card>
                <v-card-title>{{$t("common.warning")}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="text--primary">
                    {{$t("eventWaiver.warning_open_waiver")}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :color="buttonColor" @click="dialogWarningWaiver = false" class="white--text mx-1">{{$t("common.cancel")}}</v-btn>
                    <v-btn :color="buttonColor" class="white--text mx-1" @click="confirmOpenWaiver()">
                        {{$t("common.open")}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import WarningAlert from "@/components/alert/WarningAlert";
import { VRow, VCol, VBtn, VDataTable, VDialog, VIcon, VDivider,
         VCard, VCardTitle, VCardText, VTextField, VCardActions, VSpacer } from 'vuetify/lib';
import { mapState, mapGetters } from 'vuex';
import LocalStorageService from "@/services/LocalStorageService";
import Snack from "@/components/notifications/Snack";
import EventWaiverService from "@/services/EventWaiverService";

export default {
  name: "Spectators",
  components: {
    WarningAlert, Snack,   
    VRow, VCol, VDataTable, VBtn, VIcon, VDialog, VCard, VCardTitle, VCardText, VCardActions, VSpacer,
    VTextField,VDivider
  },
  data() {
      return {
        waiverItems: [],
        buttonColor: "#000",
        search: '',
        bandCreate: false,
        snackbar: false,
        msg_snackbar: "",
        color_snackbar: "",
        dialogDelete: false,
        waiverItem: null,
        disabledDelete: false,
        borderAlertColor: "",
        waiverLinkOpen: "",
        iconAlertColor: "",
        dialogWarningWaiver: false,
        bgAlertColor: "",
        filters: {
          promoterName:[],
          eventName: [],
          eventDate: [],
          participantName:[],
          participantLastname:[],
          waiverStatus:[],
          participantType:[]
        },
        loadingData: true
      };
  },
  computed: {
    ...mapState({
        user: (state) => state.session.user,
        age18: (state) => state.session.age18
    }),
    ...mapGetters({
      env: "env"
    }), 
    waiverHeader() {
        let headers = [
            {   
                text: this.$t("eventWaiver.view"),
                value: "view",
                sortable: false
            },
            { text: this.$t("eventWaiver.promoter"), value: "promoterName" },
            { text: this.$t("eventWaiver.event_name"), value: "eventName" },
            { text: this.$t("eventWaiver.event_date"), value: "eventDate" },
            { text: this.$t("eventWaiver.first_name"), value: "participantName" },
            { text: this.$t("eventWaiver.last_name"), value: "participantLastname" },
            { text: this.$t("eventWaiver.waiver_status"), value: "waiverStatus" , sortable: true },
            { text: this.$t("eventWaiver.registrant_type"), value: "participantType" },
            {
                text: this.$t("riders.actions"),
                value: "actions",
                sortable: false
            }
        ];
        return headers;
    },
    filteredWaivers() {
      const defaultPromoter = this.env.get('VUE_APP_DEFAULT_PROMOTER');

      return this.waiverItems.filter(d => 
      {
        const filteredItems = (
          Object.keys(this.filters).every(f => 
          {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
          })
        )

        return defaultPromoter ? filteredItems && d.promoterId == defaultPromoter : filteredItems;
      });
    },
    headers() {
      return [
            {   
                text: this.$t("eventWaiver.view"),
                value: "view",
                sortable: false
            },
            { text: this.$t("eventWaiver.promoter"), value: "promoterName" },
            { text: this.$t("eventWaiver.event_name"), value: "eventName" },
            { text: this.$t("eventWaiver.event_date"), value: "eventDate" },
            { text: this.$t("eventWaiver.first_name"), value: "participantName" },
            { text: this.$t("eventWaiver.last_name"), value: "participantLastname" },
            { text: this.$t("eventWaiver.waiver_status"), value: "waiverStatus" , sortable: true },
            { text: this.$t("eventWaiver.registrant_type"), value: "participantType" },
            {
                text: this.$t("riders.actions"),
                value: "actions",
                sortable: false
            }
        ];
    }
  },
  created() {
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    this.borderAlertColor = this.$store.getters.env.get('VUE_APP_BORDER_ALERT_REGULAR');    
    this.iconAlertColor = this.$store.getters.env.get('VUE_APP_ICON_ALERT_REGULAR');    
    this.bgAlertColor = this.$store.getters.env.get('VUE_APP_BG_ALERT_REGULAR');   
  },
  mounted() {
      this.getRegistrants();
      const param = LocalStorageService.getItem("show_snack_bar");
      if(param) {
        LocalStorageService.removeItem("show_snack_bar");
        this.showSnackBar(param);
      }  
  },
  methods: {
    customFilter(value, search, item) {
      if (!search) return true;

      const s = search.toLowerCase();

      const formattedDate = this.$options.filters
        .formatDateForHumans(item.eventDate, false)
        ?.toLowerCase();

      const status = this.$te(`common.${item.waiverStatus}`)
        ? this.$t(`common.${item.waiverStatus}`).toLowerCase()
        : item.waiverStatus.toLowerCase();

      const participantType = this.$te(`common.${item.participantType}`)
        ? this.$t(`common.${item.participantType}`).toLowerCase()
        : item.participantType.toLowerCase();

      return [
        formattedDate,
        status,
        participantType,
        item.promoterName.trim().toLowerCase(),
        item.eventName.trim().toLowerCase(),
        item.participantName.trim().toLowerCase(),
        item.participantLastname.trim().toLowerCase()
      ].some(v => v && v.includes(s));
    },
    addRegistrant() { 
      LocalStorageService.setItem("link_back_event_waiver", this.$route.name);
      this.$router.push({ name: 'EventWaiverCreate' }); 
    },
    getRegistrants() {
      this.$emit('changeLoadingStep', true);
      EventWaiverService.getLinkedMembersWaiver().then((resp) => {
        this.$emit('changeLoadingStep', false);
        this.loadingData = false;
        if(resp.data.success) {
          this.waiverItems = resp.data.message;
        }
      }).catch(() => { this.loadingData = false; });
      
    },
    columnValueList(val) {
      return this.waiverItems.map(d => d[val])
    },
    view(item) {
        this.dialogWarningWaiver = true;
        this.waiverLinkOpen = this.$store.getters.env.get('VUE_APP_LIVELAPS_HOST')+item.waiverLink;
    },
    confirmOpenWaiver() {
          this.dialogWarningWaiver = false;
          window.open(this.waiverLinkOpen, '_blank');
    },
    deleteItem(item) {
        this.waiverItem = item;
        this.dialogDelete = true;
    },
    showSnackBar({ msg, color }){
        this.snackbar = true;
        this.msg_snackbar = msg;
        this.color_snackbar = color;
        setTimeout(() => this.snackbar = false, 3000);
    },
    closeDelete() {
      this.waiverItem = null;
      this.dialogDelete = false;
    },
    deleteItemConfirm() {
      this.disabledDelete = true;
      EventWaiverService.deleteWaiver(this.waiverItem.ewsId).then((resp) => {
        if(resp.data.success && resp.data.message) {
          this.disabledDelete = false;
          this.dialogDelete = false;
          this.loadingData = true;
          this.getRegistrants();
        } else {
          this.showSnackBar({ msg: this.$t("common.error_general"), color: "error" });
        }
      });
    },
    goEventRegistration() {
      this.$router.push({ name: 'RegisterEventLegacy' });
    }
  }
};
</script>

<style>
.eventWaiver .v-data-table-header,
.eventWaiver .v-card__title {
  background: #ccc;
}
.mt16 {
  margin-top: 16px;
}
.btn{
  color:#fff !important;
}
.v-card__actions{
  display: inherit;
  text-align: right;
}

</style>